<script lang="ts">
  import { deviceMeta, serialPort } from "$lib/serial/connection";
  import { actionTooltip } from "$lib/title";
  import GenericLayout from "$lib/components/layout/GenericLayout.svelte";
  import { activeProfile, activeLayer } from "$lib/serial/connection";
  import { fade, fly } from "svelte/transition";
  import { restoreFromFile } from "$lib/backup/backup";
  import type { CompiledLayout } from "$lib/assets/layouts/layout.d.ts";

  const layouts: Record<string, (() => Promise<CompiledLayout>) | undefined> = {
    ONE: () =>
      import("$lib/assets/layouts/one.layout.yml").then(
        (it) => it.default as CompiledLayout,
      ),
    TWO: () =>
      import("$lib/assets/layouts/one.layout.yml").then(
        (it) => it.default as CompiledLayout,
      ),
    LITE: () =>
      import("$lib/assets/layouts/lite.layout.yml").then(
        (it) => it.default as CompiledLayout,
      ),
    X: () =>
      import("$lib/assets/layouts/103-key.layout.yml").then(
        (it) => it.default as CompiledLayout,
      ),
    ZERO: () =>
      import("$lib/assets/layouts/103-key.layout.yml").then(
        (it) => it.default as CompiledLayout,
      ),
    M4G: () =>
      import("$lib/assets/layouts/m4g.layout.yml").then(
        (it) => it.default as CompiledLayout,
      ),
    M4GR: () =>
      import("$lib/assets/layouts/m4gr.layout.yml").then(
        (it) => it.default as CompiledLayout,
      ),
    CCB: () =>
      import("$lib/assets/layouts/ccb.layout.yml").then(
        (it) => it.default as CompiledLayout,
      ),
  };
</script>

<div class="container">
  {#if $serialPort}
    {#await layouts[$serialPort.device]?.() then layoutInfo}
      <fieldset transition:fade>
        <div class="layers">
          {#each Array.from({ length: $serialPort.layerCount }, (_, i) => i) as layer}
            <label>
              <input
                type="radio"
                onclick={() => ($activeLayer = layer)}
                name="layer"
                value={layer}
                checked={$activeLayer === layer}
              />
              {String.fromCodePoint(
                "A".codePointAt(0)! + $activeProfile,
              )}{layer + 1}
            </label>
          {/each}
        </div>
        {#if $deviceMeta?.factoryDefaults?.layout}
          <button
            {@attach actionTooltip("Reset Layout")}
            transition:fly={{ x: -8 }}
            class="icon reset-layout"
            onclick={() =>
              restoreFromFile($deviceMeta!.factoryDefaults!.layout)}
            >reset_wrench</button
          >
        {/if}
      </fieldset>

      {#if layoutInfo}
        <GenericLayout {layoutInfo} />
      {/if}
    {/await}
  {/if}
</div>

<style lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    max-height: 20cm;
  }

  fieldset {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;

    border: none;

    padding: 8px;
  }

  .layers {
    display: flex;
    justify-content: center;
    align-items: center;

    gap: 2px;

    margin-inline: auto;
  }
</style>
